import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import priorityImg from '../../assets/newmonaassets/image_samet_client.jpg';
import './Priority.scss';
import { LanguageContext } from '../../context/LanguageContext';

const Priority = () => {
    const { t } = useContext(LanguageContext);

    return (
        <section className='priority-section emergency-section' data-aos="fade-up" data-aos-duration="2000">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6">
                        <div className="priority-img">
                            <img src={priorityImg} alt={t('priority.title')} />
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="priority-text">
                            <SectionTitle 
                                subTitle={t('priority.sectionTitle')} 
                                title={t('priority.title')}
                                description={t('priority.description')}
                            />

                            <div className="theme-btn">
                                <Link to='/'>{t('priority.button')}</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Priority;